'use client'

import React, { useEffect } from 'react'
import tippy from 'tippy.js'
// 從 size 改過來的
export default function Option1({ ProductID, Data = [], onChange }) {
  useEffect(() => {
    tippy('[data-tippy-content]')
  }, [])

  return (
    <>
      {Data.map((elm, i) => (
        <React.Fragment key={`swatch-option1-${ProductID}-${i + 1}`}>
          <input
            type="radio"
            name={`option1-${ProductID}`}
            id={`swatch-option1-${ProductID}-${i + 1}`}
            value={elm}
            onChange={() => onChange && onChange(elm)}
          />
          <label
            className="swatch js-swatch"
            htmlFor={`swatch-option1-${ProductID}-${i + 1}`}
            aria-label={elm}
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            data-tippy-content={elm}
          >
            {elm}
          </label>
        </React.Fragment>
      ))}
    </>
  )
}
